export interface AgencyDto {
  readonly id: number;
  readonly name: string;
  readonly sortOrder: number;
  readonly descriptionIds: number[];
  readonly locationIds: number[];
}

export class Agency {
  readonly id: number;
  readonly name: string;
  readonly sortOrder: number;
  readonly descriptionIds: number[];
  readonly locationIds: number[];

  constructor(dto: AgencyDto) {
    this.id = dto.id;
    this.name = dto.name;
    this.sortOrder = dto.sortOrder;
    this.descriptionIds = dto.descriptionIds;
    this.locationIds = dto.locationIds;
  }
}
